export const ContactRoutes = [{
    path: '/contact',
    component: () => import('./Contact.vue'),
    meta: {
      crumbName: '联系我们',
    },
    children: [
      {
        path: '',
        name: '联系我们',
        component: () => import('../index.vue'),
        meta: {
          //标明是否需要登录后才能访问
          auth:false,
        }
      }
    ]
  }]
  


// WEBPACK FOOTER //
// ./src/pages/Contact/router/Contact.routes.js